import { useRef } from 'react'
import { Typography } from '../../common/typography'
import classes from './CircularTimer.module.css'

interface CircularTimerProps {
  remainingSeconds: number
  totalSeconds: number
}

function formatTime(seconds: number): string {
  const mins = Math.floor(seconds / 60)
  const secs = seconds % 60
  return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`
}

export default function CircularTimer({
  remainingSeconds,
  totalSeconds,
}: CircularTimerProps) {
  const size = 56
  const strokeWidth = 3
  const radius = (size - strokeWidth) / 2
  const circumference = 2 * Math.PI * radius

  const initialElapsed = useRef(totalSeconds - remainingSeconds)

  return (
    <div className={classes.container}>
      <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`}>
        <circle
          className={classes.trackCircle}
          cx={size / 2}
          cy={size / 2}
          r={radius}
          strokeWidth={strokeWidth}
          transform={`rotate(-90 ${size / 2} ${size / 2})`}
        />
        <circle
          className={classes.progressCircle}
          cx={size / 2}
          cy={size / 2}
          r={radius}
          strokeWidth={strokeWidth}
          strokeDasharray={circumference}
          style={
            {
              '--circumference': circumference,
              '--duration': `${totalSeconds}s`,
              '--elapsed': initialElapsed.current,
            } as React.CSSProperties
          }
        />
      </svg>
      <div className={classes.timeText}>
        <Typography
          fs="sm"
          lh="140"
          fc={{ light: 'primary-5', dark: 'primary-3' }}
          fw={600}
          className={classes.time}
        >
          {formatTime(remainingSeconds)}
        </Typography>
      </div>
    </div>
  )
}
